import {ErrorHandler, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ZLoggerService} from './zlogger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(
        private _zLoggerService: ZLoggerService,
    ) {
    }

    handleError(error: Error | HttpErrorResponse): void {
        this._zLoggerService.debug(error);
        console.error(error);
    }
}
